<template>
    <div class="col-12">

        <div class=" row text-center ml-5">
            <h3 class="ui inverted purple text"><strong>Select Documents Upload Option</strong>
            </h3>
            <p class="text-muted fw-light mt-4">Please note every account creation request made on this platform requires a
                deposit through EcoCash.</p>
        </div>

        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">

                <div class="row mb-5">
                    <div class="col-sm-6 mb-3">
                        <div class="card card-shadow">
                            <div class="card-body">
                                <h4 class="card-title"><strong>Upload Documents Now</strong></h4>
                                <p class="card-text text-muted fw-light">Upload required documents now</p>
                                <button class="ui purple right floated  button" @click="now()">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <div class="card card-shadow">
                            <div class="card-body">
                                <h4 class="card-title"><strong>Upload Documents Later</strong></h4>
                                <p class="card-text text-muted fw-light">Requires the customer to share the documents with
                                    our Sales Team.</p>
                                <button class="ui purple right floated button" @click="later()">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5">
                    <button @click="back()" class="ui grey button fluid">Back</button>
                </div>

            </div>
        </div>


    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";

export default {
    name: "UploadDocumentsOptions",
    data() {
        return { accounts: [], };
    },
    mounted() {
    },
    methods: {

        back() {
            this.$router.push("/account-opening/signature");
        },
        now() {
            localStorage.setItem("document-option", "now");
            this.$router.push("/account-opening/current-upload-documents");
        },
        later() {
            localStorage.setItem("document-option", "later");
            this.$router.push("/account-opening/payments");
        },
        submitForm() { },
        ...baseMethods,
    }
};
</script>